import defaultConfigs from './default';

const AWS = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id:
    'eu-west-1:f9df7f25-1a29-4e40-8a11-d6fc653b1aca',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_bgmGnuw1j',
  aws_user_pools_web_client_id: '7ht1vplrj1h0h530jk9an6otgp',
  oauth: {},
  aws_appsync_graphqlEndpoint:
    'https://fchwrcr6knhibg7d5l37rb6btu.appsync-api.eu-west-1.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: 'da2-fakeApiId123456',
  aws_cloud_logic_custom: [
    {
      name: 'userapi',
      endpoint: 'https://q38jtvz7j7.execute-api.eu-west-1.amazonaws.com/loss',
      region: 'eu-west-1',
    },
  ],
  aws_user_files_s3_bucket: 'clinicardstorage91345-loss',
  aws_user_files_s3_bucket_region: 'eu-west-1',
  Auth: {
    cookieStorage: {
      domain:
        process.env.NODE_ENV === 'production'
          ? 'loss.clinicards.app'
          : 'localhost',
      path: '/',
      expires: 1,
      secure: process.env.NODE_ENV === 'production',
    },
  },
};

const defaultCarepathCards = [];

export default {
  ...defaultConfigs,
  APP_TITLE: 'LOSS',
  ENABLE_ARTICLES: true,
  AWS,
  defaultCarepathCards,
};
